import styled, { css } from 'styled-components';

export const CardContainer = styled.a(
  ({ theme }) => css`
    background-color: ${theme.co.neutral99};
    border: ${theme.bo.mediumWidth} solid ${theme.co.neutral90};
    border-radius: ${theme.bo.mediumLarge};
    padding: ${theme.sz.s4};
    display: flex;
    align-items: center;
    gap: ${theme.sz.s3};
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    transition: all 0.2s ease;
    width: 100%;
    max-width: 100%;
    height: 100%;
    min-height: fit-content;

    &:hover {
      background-color: ${theme.co.neutral95};
      border-color: ${theme.co.primary60};
    }
  `,
);

export const IconContainer = styled.div(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${theme.sz.s12};
    height: ${theme.sz.s12};
    background-color: ${theme.co.primary90};
    border-radius: ${theme.bo.medium};
    flex-shrink: 0;

    svg {
      width: ${theme.sz.s6};
      height: ${theme.sz.s6};
      color: ${theme.co.primary30};
    }
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s1};
    flex: 1;
  `,
);

export const Title = styled.div(
  ({ theme }) => css`
    ${theme.typography.heading.desktop.xxs};
    color: ${theme.co.neutral10};
  `,
);

export const Description = styled.div(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    color: ${theme.co.neutral40};
  `,
);
